import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-dynamics",
  "use": "foquz-icon-dynamics-usage",
  "viewBox": "0 0 14 11",
  "content": "<symbol viewBox=\"0 0 14 11\" fill=\"none\" id=\"foquz-icon-dynamics\"><path d=\"M13 2l-3 3-2-2-3 3m8 4H1V1\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol